import { module as Module } from 'modujs'
import { html } from '../utils/environment'

export default class extends Module {
  constructor(m) {
    super(m)

    this.events = {
      click: 'open',
    }
  }

  init() {
    this.data = {
      src: this.el.dataset.videoSrc,
      poster: this.el.dataset.videoPoster,
    }
  }

  open() {
    if (!html.classList.contains('has-modal-video-open')) {
      this.call('open', this.data, 'ModalVideo')
    }
  }
}
